
import { Stepper } from "@mantine/core";
import { StyledStepper } from "../../../../components/stepper";
import { IconDot } from "../../../../components/svg";
import { useTranslation } from "react-i18next";





export const OrganizationOnboardStepper = ({ activeStep, setActiveStep }) => {
    const { t } = useTranslation();

    const steps = [
        t("ORGANIZATION.ONBOARD.STEPPER.DETAILS"),
        t("ORGANIZATION.ONBOARD.STEPPER.PRODUCTS"),
        t("ORGANIZATION.ONBOARD.STEPPER.REVIEW"),
    ]

    return <StyledStepper active={activeStep} onStepClick={setActiveStep} >
        {steps.map((step, index) => (
            <Stepper.Step
                key={index}
                label={step}
                icon={<IconDot height={16} width={16} fill={activeStep >= index ? '#392ed6' : '#E9EAEB'} />}
                progressIcon={<IconDot height={16} width={16} fill={activeStep >= index ? '#392ed6' : '#E9EAEB'} />}
                sx={{
                    '.mantine-Stepper-stepIcon': {
                        borderColor: activeStep >= index ? '#392ed6 !important' : '#E9EAEB !important',
                    }
                }}
            />
        ))}
    </StyledStepper>
}